<template>
  <b-sidebar id="addStaffDrawer" ref="addStaffDrawer" title="Add New Staff" right shadow>
    <!-- <template #header="{hide}">

    </template> -->
    <div class="d-flex flex-column p-3 justify-content-center">
        <div class="d-flex flex-column mb-2">
            <label for="">Outlet</label>
                    <div class="input-group-prepend w-100">
                  <label
                    class="
                      input-group-text
                      border-top-right-radius-0
                      border-bottom-right-radius-0
                      border-right-0
                    "
                  >
                    <i class="fas fa-store"></i>
                  </label>
                  <multiselect
                    v-model="selectedOutlet"
                    label="text"
                    track-by="id"
                    :options="outlet"
                    :searchable="false"
                    :show-labels="false"
                    openDirection="below"
                  >
                    <template slot="option" slot-scope="{ option }">{{
                      option.text
                    }}</template>
                  </multiselect>
                </div>
        </div>
      <div class="d-flex flex-column mb-2">
        <label for="">Name</label>
                <b-input-group>
          <b-form-input v-model="staffForm.name" type="text"></b-form-input>
          <template #prepend>
            <b-input-group-text>
              <b-icon icon="person"></b-icon>
            </b-input-group-text>
          </template>
        </b-input-group>
      </div>
      <div class="d-flex flex-column mb-2">
        <label for="">Contact</label>
        <b-input-group>
          <b-form-input v-maska data-maska="6z" data-maska-tokens="z:[0-9]:multiple" v-model="staffForm.mobile" type="text"></b-form-input>
          <template #prepend>
            <b-input-group-text>
              <b-icon icon="phone"></b-icon>
            </b-input-group-text>
          </template>
        </b-input-group>
        
      </div>
      <div class="d-flex flex-column mb-2">
        <label for="">Details</label>
              <b-form-textarea
    id="textarea-rows"
    placeholder="Enter Cust Details"
    v-model="staffForm.detail"
    rows="4"
  ></b-form-textarea>
      </div>
      <div class="d-flex flex-column mb-2">
        <b-form-checkbox class="mb-1" v-model="staffForm.showOnline" switch>Show for Online</b-form-checkbox>
        <b-form-checkbox class="mb-1" v-model="staffForm.showAppt" switch>Show for Appointment</b-form-checkbox>
        <b-form-checkbox v-model="staffForm.showWork" switch>Show for Worksheet</b-form-checkbox>
      </div>
    </div>
    <div class="d-flex justify-content-end p-3">
        <div class="d-flex">
            <b-button v-b-toggle.addStaffDrawer>Cancel</b-button>
            <b-button class="mx-2" @click="clearForm()" variant="info">Reset</b-button>
            <b-button variant="primary" :disabled="selectedOutlet === null || this.staffForm.name === '' || this.staffForm.mobile === ''" @click="addStaff()">Save</b-button>
        </div>
    </div>
  </b-sidebar>
</template>
<script>
import { handleSessionExpired } from '../../../../assets/js/dashboard/dashboard';
import { vMaska } from "maska";
export default {
  name: "staffFormDrawer",
    directives: { maska: vMaska },
  props:{
    outlet:Array,
    selected:Object
  },
  data(){
    return{
        selectedOutlet:{},
        staffForm:{
            name:"",
            mobile:"",
            detail:"",
            showAppt:false,
            showOnline:false,
            showWork:false,
        }
    }
  },
  mounted(){
    this.selectedOutlet = this.$props.selected;
  },
  watch:{
    selected(){
      this.selectedOutlet = this.$props.selected;
    }
  },
  methods:{
    clearForm(){
      this.selectedOutlet = null;
      this.staffForm.name = "";
      this.staffForm.detail = "";
      this.staffForm.mobile = "";
      this.staffForm.showAppt = false;
      this.staffForm.showOnline = false;
      this.staffForm.showWork = false;
    },
    async addStaff(){
        let $vm = this;
        let url = this.$api.BEBUSINESS_STAFF;
        let result = [];
        await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: {
            name:$vm.staffForm.name,
            outletID:$vm.selectedOutlet.id,
            mobile:$vm.staffForm.mobile,
            showAppt:$vm.staffForm.showAppt ? 1:0,
            showOnline:$vm.staffForm.showOnline ? 1:0,
            showWork:$vm.staffForm.showWork ? 1:0
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        this.$emit("addDone",result)

        this.$refs.addStaffDrawer.hide()
    }
  }
};
</script>
<style lang="scss">
.avatar-wrapper{
	position: relative;
	height: 200px;
	width: 200px;
	margin: 50px auto;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 1px 1px 15px -5px black;
	transition: all .3s ease;
	&:hover{
		transform: scale(1);
		cursor: pointer;
	}
	&:hover .profile-pic{
		opacity: .5;
	}
	.profile-pic {
    height: 100%;
		width: 100%;
		transition: all .3s ease;
		&:after{
			font-family: FontAwesome;
			content: "\f007";
			top: 0; left: 0;
			width: 100%;
			height: 100%;
			position: absolute;
			font-size: 190px;
			background: #ecf0f1;
			color: #34495e;
			text-align: center;
		}
	}
	.upload-button {
		position: absolute;
		top: 0; left: 0;
		height: 100%;
		width: 100%;
		.fa-arrow-circle-up{
			position: absolute;
			font-size: 234px;
			top: -17px;
			left: 0;
			text-align: center;
			opacity: 0;
			transition: all .3s ease;
			color: #34495e;
		}
		&:hover .fa-arrow-circle-up{
			opacity: .9;
		}
	}
}
</style>